import { useEffect, useState } from 'react';
import { PanelText } from '../../../ui';

const SavingResultsMsg = () => {
  const [messageText, setMessageText] = useState(`Saving results, please wait...`);

  useEffect(() => {
    const slowConnectionTimeout = setTimeout(() => {
      setMessageText(`Saving is taking a while due to slow connection...`);
    }, 15000);
    const abandonSavingTimeout = setTimeout(() => {
      setMessageText(
        `Sorry, saving is taking a very long time. You may not be able to upload these results. You can keep waiting, or use the ☰ menu to leave this page. Otherwise, we'll keep trying.`,
      );
    }, 45000);

    return () => {
      clearTimeout(slowConnectionTimeout);
      clearTimeout(abandonSavingTimeout);
    };
  }, []);

  return (
    <PanelText role='status' style={{ maxWidth: 520 }}>
      {messageText}
    </PanelText>
  );
};

export default SavingResultsMsg;
